/** "Send the link again" for a self-signed-up teacher who has not confirmed yet: on the
 * check-your-email screen after sign-up, and on sign-in when the issuer answered
 * `email_unconfirmed`. The answer is the same for every address (the server never says whether
 * an account exists), so the sentence after a send is careful to promise nothing more. */
import { useState } from "react";
import { useTranslation } from "react-i18next";

import { Button } from "../ui";
import { resendConfirmation } from "./session";
import type { ResendOutcome } from "./signupRules";

export function ResendConfirmation({ email }: { email: string }) {
  const { t } = useTranslation();
  const [busy, setBusy] = useState(false);
  const [outcome, setOutcome] = useState<ResendOutcome | null>(null);

  async function send() {
    setBusy(true);
    setOutcome(null);
    setOutcome(await resendConfirmation(email));
    setBusy(false);
  }

  return (
    <div className="flex flex-col gap-2">
      <Button variant="secondary" loading={busy} disabled={!email.trim()} onClick={() => void send()}>
        {t("confirmEmail.resend")}
      </Button>
      <p role="status" aria-live="polite" className={`text-sm ${outcome === "sent" ? "text-[color:var(--ink-2)]" : "text-[color:var(--danger)]"}`}>
        {outcome && t(`confirmEmail.${outcome}`)}
      </p>
    </div>
  );
}
